import React from 'react';
import { Fade } from 'react-awesome-reveal';

import {
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  Container,
} from '../../../components';

import './style.scss';

const ParagraphImages = ({ entity, containerless }) => {
  const images = entity.get('field_images');
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  if (containerless) {
    return (
      <div id={paragraphKey} className="Paragraph ParagraphImages">
        <Fade triggerOnce bottom distance="50px" duration={500}>
          <>
            { images.map((image, i) => {
              const imageSrc = image.getIn(['styles', 'basic_image'], '');
              const imageUuid = image.getIn(['target_uuid'], '');
              return (
                <div className="ParagraphImages__image" key={`ParagraphImages__image--${imageUuid}`}>
                  <Image
                    src={{
                      0: image.getIn(['styles', 'large'], ''),
                      768: imageSrc,
                    }}
                    includeWebP
                  />
                </div>
              );
            }) }
          </>
        </Fade>
      </div>
    );
  }
  return (
    <Container id={paragraphKey} small className="Paragraph">
      <div className="ParagraphImages">
        <Fade triggerOnce bottom distance="50px" duration={500}>
          <>
            { images.map((image, i) => {
              const imageSrc = image.getIn(['styles', 'basic_image'], '');
              const imageUuid = image.getIn(['target_uuid'], '');
              return (
                <div className="ParagraphImages__image" key={`ParagraphImages__image--${imageUuid}`}>
                  <Image
                    src={{
                      0: image.getIn(['styles', 'large'], ''),
                      768: imageSrc,
                    }}
                    includeWebP
                  />
                </div>
              );
            }) }
          </>
        </Fade>
      </div>
    </Container>
  );
};

export default ParagraphImages;
